import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadRoute } from "../../api/routes";

export function useUploadRoute() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: uploadRoute,
    onSuccess: () => {
      console.log("Route uploaded successfully");
      queryClient.invalidateQueries({ queryKey: ["routes"] });
    },
    onError: (err) => console.error("Error uploading route:", err),
  });
}